import React from "react"
import { Link } from "gatsby"
import { AnimatePresence } from "framer-motion"
import { Wrapper, Chapter } from "./styles"

const Chapters = ({ isVisible, routes, currentRoute }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <Wrapper
          initial={{ transform: "translateY(-100%)" }}
          animate={{
            transform: "translateY(0%)",
            transition: { duration: 0.5 },
          }}
          exit={{
            transform: "translateY(-100%)",
            transition: { duration: 0.5, delay: 0.7 },
          }}
        >
          <ul>
            {routes.map(r => (
              <Chapter
                key={r.route.content}
                isActive={currentRoute?.url === r.route.content}
              >
                <Link to={r.route.content}>{r.name.content}</Link>
              </Chapter>
            ))}
          </ul>
        </Wrapper>
      )}
    </AnimatePresence>
  )
}

export default Chapters
